import { render, staticRenderFns } from "./XKZ.vue?vue&type=template&id=71d5c925&scoped=true&"
import script from "./XKZ.vue?vue&type=script&lang=js&"
export * from "./XKZ.vue?vue&type=script&lang=js&"
import style0 from "./XKZ.vue?vue&type=style&index=0&id=71d5c925&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d5c925",
  null
  
)

export default component.exports